"use client";

import { c as _c } from "react/compiler-runtime";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { NFTSubscription } from "@/generated/models/NFTSubscription";
import { RedeemedSubscription } from "@/generated/models/RedeemedSubscription";
import { SubscriptionDetails } from "@/generated/models/SubscriptionDetails";
import { SubscriptionLog } from "@/generated/models/SubscriptionLog";
import { SubscriptionTopUp } from "@/generated/models/SubscriptionTopUp";
import { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AuthContext } from "@/components/auth/Auth";
import { getCardsRemainingUntilEndOf, isMintingToday } from "@/components/meme-calendar/meme-calendar.helpers";
import { Page } from "@/helpers/Types";
import { commonApiFetch } from "@/services/api/common-api";
import Link from "next/link";
import UserPageSubscriptionsAirdropAddress, { AirdropAddressResult } from "./UserPageSubscriptionsAirdropAddress";
import UserPageSubscriptionsBalance from "./UserPageSubscriptionsBalance";
import UserPageSubscriptionsEditionPreference from "./UserPageSubscriptionsEditionPreference";
import UserPageSubscriptionsHistory from "./UserPageSubscriptionsHistory";
import UserPageSubscriptionsMode from "./UserPageSubscriptionsMode";
import UserPageSubscriptionsTopUp from "./UserPageSubscriptionsTopUp";
import UserPageSubscriptionsUpcoming from "./UserPageSubscriptionsUpcoming";
const HISTORY_PAGE_SIZE = 10;
export default function UserPageSubscriptions(props) {
  const $ = _c(98);
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const [profileKey, setProfileKey] = useState();
  const [isFetching, setIsFetching] = useState(true);
  const [details, setDetails] = useState();
  const [fetchingDetails, setFetchingDetails] = useState(true);
  const [airdropResult, setAirdropResult] = useState();
  const [fetchingAirdropAddress, setFetchingAirdropAddress] = useState(true);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      count: 0,
      page: 1,
      next: false,
      data: []
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [topUpHistory, setTopUpHistory] = useState(t0);
  const [fetchingTopUpHistory, setFetchingTopUpHistory] = useState(true);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      count: 0,
      page: 1,
      next: false,
      data: []
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [redeemedHistory, setRedeemedHistory] = useState(t1);
  const [fetchingRedeemedHistory, setFetchingRedeemedHistory] = useState(true);
  const remainingMintsForSeason = getCardsRemainingUntilEndOf("szn");
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [memeSubscriptions, setMemeSubscriptions] = useState(t2);
  const [fetchingMemeSubscriptions, setFetchingMemeSubscriptions] = useState(true);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      count: 0,
      page: 1,
      next: false,
      data: []
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [subscriptionLogs, setSubscriptionLogs] = useState(t3);
  const [fetchingSubscriptionLogs, setFetchingSubscriptionLogs] = useState(true);
  const [isConnectedAccount, setIsConnectedAccount] = useState(false);
  let t4;
  if ($[4] !== activeProfileProxy || $[5] !== connectedProfile?.consolidation_key || $[6] !== connectedProfile?.wallets || $[7] !== props.profile) {
    t4 = () => {
      if (activeProfileProxy) {
        setIsConnectedAccount(false);
        setProfileKey(undefined);
        return;
      }
      const connectedKey = connectedProfile?.consolidation_key ?? connectedProfile?.wallets?.map(_temp).join("-");
      const pKey = props.profile.consolidation_key ?? props.profile.wallets?.map(_temp2).join("-");
      setIsConnectedAccount(connectedKey === pKey);
      setProfileKey(pKey);
    };
    $[4] = activeProfileProxy;
    $[5] = connectedProfile?.consolidation_key;
    $[6] = connectedProfile?.wallets;
    $[7] = props.profile;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== activeProfileProxy || $[10] !== connectedProfile || $[11] !== props.profile) {
    t5 = [connectedProfile, activeProfileProxy, props.profile];
    $[9] = activeProfileProxy;
    $[10] = connectedProfile;
    $[11] = props.profile;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[13] !== fetchingAirdropAddress || $[14] !== fetchingDetails || $[15] !== fetchingMemeSubscriptions || $[16] !== fetchingRedeemedHistory || $[17] !== fetchingSubscriptionLogs || $[18] !== fetchingTopUpHistory) {
    t6 = () => {
      setIsFetching(fetchingDetails || fetchingAirdropAddress || fetchingTopUpHistory || fetchingMemeSubscriptions || fetchingSubscriptionLogs || fetchingRedeemedHistory);
    };
    t7 = [fetchingDetails, fetchingAirdropAddress, fetchingTopUpHistory, fetchingMemeSubscriptions, fetchingSubscriptionLogs, fetchingRedeemedHistory];
    $[13] = fetchingAirdropAddress;
    $[14] = fetchingDetails;
    $[15] = fetchingMemeSubscriptions;
    $[16] = fetchingRedeemedHistory;
    $[17] = fetchingSubscriptionLogs;
    $[18] = fetchingTopUpHistory;
    $[19] = t6;
    $[20] = t7;
  } else {
    t6 = $[19];
    t7 = $[20];
  }
  useEffect(t6, t7);
  let t8;
  if ($[21] !== profileKey) {
    t8 = function fetchDetails() {
      if (!profileKey) {
        return;
      }
      setFetchingDetails(true);
      commonApiFetch({
        endpoint: `subscriptions/consolidation/details/${profileKey}`
      }).then(data => {
        setDetails(data);
      }).catch(() => {
        setDetails(undefined);
      }).finally(() => {
        setFetchingDetails(false);
      });
    };
    $[21] = profileKey;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const fetchDetails = t8;
  let t9;
  if ($[23] !== profileKey) {
    t9 = function fetchAirdropAddress() {
      if (!profileKey) {
        return;
      }
      setFetchingAirdropAddress(true);
      commonApiFetch({
        endpoint: `subscriptions/consolidation/${profileKey}/airdrop-address`
      }).then(data_0 => {
        setAirdropResult(data_0);
      }).catch(() => {
        setAirdropResult(undefined);
      }).finally(() => {
        setFetchingAirdropAddress(false);
      });
    };
    $[23] = profileKey;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const fetchAirdropAddress = t9;
  let t10;
  if ($[25] !== profileKey) {
    t10 = function fetchTopUpHistory(page) {
      if (!profileKey) {
        return;
      }
      setFetchingTopUpHistory(true);
      commonApiFetch({
        endpoint: `subscriptions/consolidation/top-up/${profileKey}?page=${page}&page_size=${HISTORY_PAGE_SIZE}`
      }).then(data_1 => {
        setTopUpHistory(data_1);
      }).finally(() => {
        setFetchingTopUpHistory(false);
      });
    };
    $[25] = profileKey;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const fetchTopUpHistory = t10;
  let t11;
  if ($[27] !== profileKey) {
    t11 = function fetchRedeemHistory(page_0) {
      if (!profileKey) {
        return;
      }
      setFetchingRedeemedHistory(true);
      commonApiFetch({
        endpoint: `subscriptions/consolidation/redeemed/${profileKey}?page=${page_0}&page_size=${HISTORY_PAGE_SIZE}`
      }).then(data_2 => {
        setRedeemedHistory(data_2);
      }).finally(() => {
        setFetchingRedeemedHistory(false);
      });
    };
    $[27] = profileKey;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  const fetchRedeemHistory = t11;
  let t12;
  if ($[29] !== profileKey) {
    t12 = function fetchMemeSubscriptions() {
      if (!profileKey) {
        return;
      }
      setFetchingMemeSubscriptions(true);
      let upcomingLimit = remainingMintsForSeason;
      if (isMintingToday()) {
        upcomingLimit = upcomingLimit + 1;
      }
      commonApiFetch({
        endpoint: `subscriptions/consolidation/upcoming-memes/${profileKey}?card_count=${upcomingLimit}`
      }).then(data_3 => {
        setMemeSubscriptions(data_3);
      }).finally(() => {
        setFetchingMemeSubscriptions(false);
      });
    };
    $[29] = profileKey;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  const fetchMemeSubscriptions = t12;
  let t13;
  if ($[31] !== profileKey) {
    t13 = function fetchLogs(page_1) {
      if (!profileKey) {
        return;
      }
      setFetchingSubscriptionLogs(true);
      commonApiFetch({
        endpoint: `subscriptions/consolidation/logs/${profileKey}?page=${page_1}&page_size=${HISTORY_PAGE_SIZE}`
      }).then(data_4 => {
        setSubscriptionLogs(data_4);
      }).finally(() => {
        setFetchingSubscriptionLogs(false);
      });
    };
    $[31] = profileKey;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  const fetchLogs = t13;
  let t14;
  if ($[33] !== fetchAirdropAddress || $[34] !== fetchDetails || $[35] !== fetchLogs || $[36] !== fetchMemeSubscriptions || $[37] !== fetchRedeemHistory || $[38] !== fetchTopUpHistory || $[39] !== profileKey) {
    t14 = () => {
      if (!profileKey) {
        return;
      }
      fetchDetails();
      fetchAirdropAddress();
      fetchTopUpHistory(1);
      fetchMemeSubscriptions();
      fetchRedeemHistory(1);
      fetchLogs(1);
    };
    $[33] = fetchAirdropAddress;
    $[34] = fetchDetails;
    $[35] = fetchLogs;
    $[36] = fetchMemeSubscriptions;
    $[37] = fetchRedeemHistory;
    $[38] = fetchTopUpHistory;
    $[39] = profileKey;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  const refresh = t14;
  let t15;
  if ($[41] !== refresh) {
    t15 = () => {
      refresh();
    };
    $[41] = refresh;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== profileKey) {
    t16 = [profileKey];
    $[43] = profileKey;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  useEffect(t15, t16);
  if (!profileKey) {
    let t17;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <></>;
      $[45] = t17;
    } else {
      t17 = $[45];
    }
    return t17;
  }
  let t17;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      className: "pb-4",
      xs: 12,
      md: 6
    };
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  const colConfig = t17;
  let t18;
  let t19;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Row><Col className="d-flex align-items-center gap-2"><h4 className="mb-0 tw-font-semibold">Subscribe</h4><span><Link href="/about/subscriptions" className="font-smaller font-color-silver decoration-hover-underline">Learn More</Link></span></Col></Row>;
    t19 = <hr className="tw-border-white tw-opacity-100 tw-border-2 tw-mt-1" />;
    $[47] = t18;
    $[48] = t19;
  } else {
    t18 = $[47];
    t19 = $[48];
  }
  let t20;
  if ($[49] !== details || $[50] !== isConnectedAccount || $[51] !== isFetching || $[52] !== refresh) {
    t20 = <Col {...colConfig}><UserPageSubscriptionsBalance details={details} fetching={isFetching} refresh={refresh} show_refresh={isConnectedAccount} /></Col>;
    $[49] = details;
    $[50] = isConnectedAccount;
    $[51] = isFetching;
    $[52] = refresh;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] !== airdropResult || $[55] !== isConnectedAccount) {
    t21 = <Col {...colConfig}><UserPageSubscriptionsAirdropAddress show_edit={isConnectedAccount} airdrop={airdropResult} /></Col>;
    $[54] = airdropResult;
    $[55] = isConnectedAccount;
    $[56] = t21;
  } else {
    t21 = $[56];
  }
  const t22 = !isConnectedAccount;
  let t23;
  if ($[57] !== details || $[58] !== profileKey || $[59] !== refresh || $[60] !== t22) {
    t23 = <Col {...colConfig}><UserPageSubscriptionsMode profileKey={profileKey} details={details} readonly={t22} refresh={refresh} /></Col>;
    $[57] = details;
    $[58] = profileKey;
    $[59] = refresh;
    $[60] = t22;
    $[61] = t23;
  } else {
    t23 = $[61];
  }
  const t24 = !isConnectedAccount;
  let t25;
  if ($[62] !== details || $[63] !== profileKey || $[64] !== refresh || $[65] !== t24) {
    t25 = <Col {...colConfig}><UserPageSubscriptionsEditionPreference profileKey={profileKey} details={details} readonly={t24} refresh={refresh} /></Col>;
    $[62] = details;
    $[63] = profileKey;
    $[64] = refresh;
    $[65] = t24;
    $[66] = t25;
  } else {
    t25 = $[66];
  }
  let t26;
  if ($[67] !== t20 || $[68] !== t21 || $[69] !== t23 || $[70] !== t25) {
    t26 = <Row className="pt-2 pb-2"><Col><Container className="no-padding">{t18}{t19}<Row>{t20}{t21}{t23}{t25}</Row></Container></Col></Row>;
    $[67] = t20;
    $[68] = t21;
    $[69] = t23;
    $[70] = t25;
    $[71] = t26;
  } else {
    t26 = $[71];
  }
  let t27;
  if ($[72] !== isConnectedAccount) {
    t27 = isConnectedAccount && <Row className="pt-4 pb-2"><Col><UserPageSubscriptionsTopUp /></Col></Row>;
    $[72] = isConnectedAccount;
    $[73] = t27;
  } else {
    t27 = $[73];
  }
  const t28 = !isConnectedAccount;
  let t29;
  if ($[74] !== details || $[75] !== memeSubscriptions || $[76] !== profileKey || $[77] !== refresh || $[78] !== t28) {
    t29 = <Row className="pt-4 pb-2"><Col><UserPageSubscriptionsUpcoming profileKey={profileKey} details={details} memes_subscriptions={memeSubscriptions} readonly={t28} refresh={refresh} /></Col></Row>;
    $[74] = details;
    $[75] = memeSubscriptions;
    $[76] = profileKey;
    $[77] = refresh;
    $[78] = t28;
    $[79] = t29;
  } else {
    t29 = $[79];
  }
  let t30;
  if ($[80] !== fetchRedeemHistory) {
    t30 = page_2 => {
      fetchRedeemHistory(page_2);
    };
    $[80] = fetchRedeemHistory;
    $[81] = t30;
  } else {
    t30 = $[81];
  }
  let t31;
  if ($[82] !== fetchTopUpHistory) {
    t31 = page_3 => {
      fetchTopUpHistory(page_3);
    };
    $[82] = fetchTopUpHistory;
    $[83] = t31;
  } else {
    t31 = $[83];
  }
  let t32;
  if ($[84] !== fetchLogs) {
    t32 = page_4 => {
      fetchLogs(page_4);
    };
    $[84] = fetchLogs;
    $[85] = t32;
  } else {
    t32 = $[85];
  }
  let t33;
  if ($[86] !== redeemedHistory || $[87] !== subscriptionLogs || $[88] !== t30 || $[89] !== t31 || $[90] !== t32 || $[91] !== topUpHistory) {
    t33 = <Row className="pt-4 pb-2"><Col><UserPageSubscriptionsHistory topups={topUpHistory} redeemed={redeemedHistory} logs={subscriptionLogs} setRedeemedPage={t30} setTopUpPage={t31} setLogsPage={t32} /></Col></Row>;
    $[86] = redeemedHistory;
    $[87] = subscriptionLogs;
    $[88] = t30;
    $[89] = t31;
    $[90] = t32;
    $[91] = topUpHistory;
    $[92] = t33;
  } else {
    t33 = $[92];
  }
  let t34;
  if ($[93] !== t26 || $[94] !== t27 || $[95] !== t29 || $[96] !== t33) {
    t34 = <Container className="no-padding pb-5">{t26}{t27}{t29}{t33}</Container>;
    $[93] = t26;
    $[94] = t27;
    $[95] = t29;
    $[96] = t33;
    $[97] = t34;
  } else {
    t34 = $[97];
  }
  return t34;
}
function _temp2(w_0) {
  return w_0.wallet;
}
function _temp(w) {
  return w.wallet;
}